<script lang="ts">
import { Accordion, AccordionItem, TabContent, TabPane } from "sveltestrap";
import { paramsService, subtypesDiligencesService } from "../services";
import AppWraper from "../components/AppWraper.svelte";
import ParamsList from "../components/paramsList.svelte";
import SubtypesList from "../components/SubtypesList.svelte";

let paramType: string;
let paramTypes: any[];
let diligenceTypes: any[] = []


let types: any[] = [
    {
        type: 'agentList',
        name: 'Agentes'
    },
    {
        type: 'agentPosition',
        name: 'Cargos policiales'
    },
    {
        type: 'streetType',
        name: 'Vias'
    },
    {
        type: 'street',
        name: 'Calles'
    },
    {
        type: 'distric',
        name: 'Barrios'
    },
    {
        type: 'municipality',
        name: 'Municipios'
    },
    {
        type: 'province',
        name: 'Provincias'
    },
    {
        type: 'country',
        name: 'Paises'
    },
    {
        type: 'complex',
        name: 'Urbanizaciones'
    },
    {
        type: 'building',
        name: 'Edificios'
    },
    {
        type: 'gender',
        name: 'Generos'
    },
    {
        type: 'kinshipRelation',
        name: 'Parentezco'
    },
    {
        type: 'vehicleType',
        name: 'Tipos de vehículos'
    },
    {
        type: 'vehicleMark',
        name: 'Marcas de vehículos'
    },
    {
        type: 'vehicleModel',
        name: 'Modelos de vehículos'
    },
    {
        type: 'insurenceCarrier',
        name: 'Aseguradoras'
    },
    {
        type: 'color',
        name: 'Colores'
    },
    {
        type: 'transportCardType',
        name: 'Tipos de trasportistas'
    },
    {
        type: 'diligencesTypes',
        name: 'Tipos de diligencias'
    },
    {
        type: 'antecedentType',
        name: 'Tipos de Antecedentes'
    },
    {
        type: 'courts',
        name: 'Cortes'
    },
    {
        type: 'etilometroSeries',
        name: 'Etilometros Series'
    },
    {
        type: 'healthStatus',
        name: 'Estado de Salud'
    },
    {
        type: 'marriageRegime',
        name: 'Regimen Matrimonio'
    },
    {
        type: 'modules',
        name: 'Modulos'
    },
    {
        type: 'profession',
        name: 'Profesión'
    },
    {
        type: 'workSituation',
        name: 'Estado Laboral'
    },
    {
        type: 'objectType',
        name: 'Tipos de Objetos'
    },
    {
        type: 'licenseType',
        name: 'Permisos de conducir'
    },
    {
        type: 'callerType',
        name: 'Tipos de Comunicantes'
    }
]

// INSERT INTO `params` (`type`)
// VALUES
// 	('agentList'),
// 	('antecedentType'),
// 	('building'),
// 	('color'),
// 	('complex'),
// 	('country'),
// 	('courts'),
// 	('diligencesTypes'),
// 	('distric'),
// 	('etilometroSeries'),
// 	('gender'),
// 	('healthStatus'),
// 	('HouseType'),
// 	('insurenceCarrier'),
// 	('kinshipRelation'),
// 	('marriageRegime'),
// 	('modules'),
// 	('municipality'),
// 	('profession'),
// 	('province'),
// 	('street'),
// 	('streetType'),
// 	('transportCardType'),
// 	('vehicleMark'),
// 	('vehicleModel'),
// 	('vehicleType'),
// 	('workSituation');


loadTypes();

async function loadTypes(): Promise<void> {
    paramTypes = await paramsService.findDiferentTypes();

    diligenceTypes = await paramsService.findByType('diligencesTypes');
    
}

</script>



<AppWraper>
    <div class="container-fluid p-5">
        <div class="container">
            <div class="row">
                <div class="col-12 col-sm-9 mb-3">
                    <div class="text-start">
                        <h3>Listados de Parámetros</h3>
                    </div>
                </div>
            <div class="col-12 col-sm-3 mb-3">
                <div class="text-end">

                </div>
            </div>

            <Accordion>
                {#each types as type, index}
                    <AccordionItem header={type.name}>
                        <ParamsList paramType={type.type}/>
                    </AccordionItem>
                {/each}
                <AccordionItem header="Subtipos diligencias">
                    <Accordion>
                        {#each diligenceTypes as diligenceType}
                            <AccordionItem header={diligenceType.name}>
                                <SubtypesList diligenceType={diligenceType.id} />
                            </AccordionItem>
                        {/each}
                    </Accordion>
                </AccordionItem>
            </Accordion>

        </div>
    </div>
</AppWraper>
